<template>
    <div>
        <base-table
            hide-default-footer
            v-bind="$attrs"
            v-on="$listeners"
            :headers="processedHeaders"
            :items="items"
            :options="options"
            @click:row="onClickRowItem">

            <template v-slot:[`item.${$constant.table.CUSTOMER_HEADER_KEY.registerDate}`]="{ item }">
                {{ $util.getDDMMYYYYHHSSDateFormat(item[$constant.table.CUSTOMER_HEADER_KEY.registerDate]) }}
            </template>

            <template v-slot:[`item.${$constant.table.CUSTOMER_HEADER_KEY.status}`]="{ item }">
                <button-status-field
                    disableClick
                    hideIcon
                    :status="item[$constant.table.CUSTOMER_HEADER_KEY.status]"/>
            </template>
        </base-table>
    </div>
</template>

<script>
import BaseTable from '@/components/tables/BaseTable'
import ExcludableTable from '@/mixins/ExcludableTable'
import ButtonStatusField from '@/components/fields/ButtonStatusField'

export default {
    name: 'CustomerTable',

    components: {
        BaseTable,
        ButtonStatusField
    },

    mixins: [ExcludableTable],

    props: {
        items: {
            type: Array,
            default: () => []
        },

        options: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            headers: [
                {
                    text: this.$t('customerList.table.header.customerId'),
                    value: this.$constant.table.CUSTOMER_HEADER_KEY.id,
                    width: '130px'
                },
                {
                    text: this.$t('customerList.table.header.firstName'),
                    value: this.$constant.table.CUSTOMER_HEADER_KEY.firstName,
                    sortable: false
                },
                {
                    text: this.$t('customerList.table.header.lastName'),
                    value: this.$constant.table.CUSTOMER_HEADER_KEY.lastName,
                    sortable: false
                },
                {
                    text: this.$t('customerList.table.header.email'),
                    value: this.$constant.table.CUSTOMER_HEADER_KEY.email,
                    sortable: false
                },
                {
                    text: this.$t('customerList.table.header.nationality'),
                    value: this.$constant.table.CUSTOMER_HEADER_KEY.nationality,
                    width: '100px',
                    sortable: false
                },
                {
                    text: this.$t('customerList.table.header.registerDate'),
                    value: this.$constant.table.CUSTOMER_HEADER_KEY.registerDate,
                    sortable: false
                },
                {
                    text: this.$t('customerList.table.header.status'),
                    value: this.$constant.table.CUSTOMER_HEADER_KEY.status,
                    width: '140px',
                    align: 'center',
                    sortable: false
                }
            ]
        }
    },

    methods: {
        onClickRowItem (item) {
            this.$emit('viewDetails', item)
        }
    }
}
</script>

<style lang="scss" scoped></style>
